import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import SearchFilters from '../../searchFilters';

export const SearchFilterWrapper: FC = () => {
  const isSearchExpanded = useSelector(
    (state: RootState) => state.layoutConfiguration.isSearchExpanded
  );

  return isSearchExpanded && <SearchFilters isOpened={isSearchExpanded} />;
};
